// creation
export const FPS = 15 // FPS to use for downsampling, display, creation, etc...
export const FRAME_DELAY = 1000 / FPS // delay between frames (in milliseconds)
export const MAX_FILE_DURATION = 40 // max allowed video duration for input files (in seconds)
export const MAX_FILE_SIZE = 100 // max file size allowed for input files (in MBs)
export const MIN_STICKER_TRANSPARENCY = 0.2 // min percentage of sticker that must be transparent (0-1)
export const MIN_OUTPUT_WIDTH = 200 // minimum width for output GIF (in pixels)
export const MAX_OUTPUT_WIDTH = 1080 // maximum width for output GIF (in pixels)
export const MAX_OUTPUT_GIF_DURATION = 20 // maximum output GIF duration (in seconds)
export const MAX_OUTPUT_STICKER_DURATION = 5 // maximum output sticker duration (in seconds)

// file types
export const STILL_MIME_TYPES = ['image/jpeg', 'image/png'] // list of accepted "still" MIME types
export const STILL_FILE_EXTENSIONS = ['.jpeg', '.jpg', '.png'] // list of accepted "still" file extensions
export const VIDEO_MIME_TYPES = ['video/mp4', 'video/mov'] // list of accepted video MIME types
export const VIDEO_FILE_EXTENSIONS = ['.mp4', '.mov', 'youtube', 'vimeo'] // list of accepted video file extensions
export const ANIMATED_MIME_TYPES = ['image/gif', ...VIDEO_MIME_TYPES] // list of accepted "animated" MIME types
export const ANIMATED_FILE_EXTENSIONS = ['.gif', ...VIDEO_FILE_EXTENSIONS] // list of accepted "animated" file extensions

// general
export const UPLOAD_BUTTON_LABEL = 'Upload to GIPHY' // label for the upload button
export const BUTTON_ACTIVE_OPACITY = 0.8 // button opacity when being pressed
export const BORDER_RADIUS_SMALL = 2 // border radius for smaller elements (in pixels)
export const BORDER_RADIUS_MEDIUM = 4 // border radius for medium elements (in pixels)
export const BORDER_RADIUS_LARGE = 6 // border radius for large elements (in pixels)

// cut out tool
export const CUT_OUT_MINIMUM_PATH_LENGTH = 3 // minimum number of points required before a path can close

// animate tool
export const ANIMATE_FRAME_PADDING = 0.15 // amount of padding to apply to the animate tool's animations (in percentage [0 - 0.5] of preview size)
export const DEFAULT_ANIMATE_STROKE_SIZE = 4 // default stroke size in the animate step (in pixels)
